angular.module('client-cards', [])
    .service('ClientCards', Cards);

Cards.$inject = ['$rootScope', '$q', 'PortalApi', 'Authentication', 'Localization', '$translate', 'Notification', '$timeout', 'Storage'];

function Cards($rootScope, $q, PortalApi, Authentication, Localization, $translate, Notification, $timeout, Storage) {

    var cardTypes = {
        2: 'master',
        5: 'master',
        6: 'maestro',
        4: 'visa'
    };

    var Cards = {
        list: [],
        listMP:[],
        mpCommission: false,
        gaPayData: {
            cardMaskedNumber: '',
            cardPaymentNetwork: '',
            type: '',//GOOGLE_PAYLOAD/APPLE_PAYLOAD
            payload: ''
        },
        data:{
            storedCardNum:'',
            numberMask:'9999 9999 9999 9999',
            userCardUsed: false,
            masterpass: false,
            card_type: '',
            target: {
                card: ''
            },
            userPaste: false,
            userPasteTo:false,
            type: '',
            showMPcards: true,
            masterpassAdd: false,
            isGAPay: false,
            applePayAvailable: false,
            googlePayAvailable: false,
            masterpassName: '',
            mpAuth: false,
            mpStatus: Storage.mp_status,
            c2c: false,
        },
        initList: function (list) {
            var mp = [];

            for (var i = 0; i < list.length; i++) {
                list[i].number = "**" +  list[i].number.substr(-2);

                if (list[i].card_type == "masterpass") {
                    mp.push(list[i]);
                    list.splice(i, 1);
                    i--;
                }
            }
            angular.extend(Cards.listMP, mp);
            angular.extend(Cards.list, list);
        },
        getCardType: function (cardHash) {
            var type = cardTypes[String(cardHash)[0]];

            if (!type) {
                Localization.notifyTemplate('success', 'NOTIFICATION.ERRORS.CARD_TYPE_E', 5, true);
            }

            return type || '';
        },
        isUnicCard: function (hash) {
            return !Cards.list.some(function (card) {
                return card.number == hash;
            });
        },
        isPrepaid: function (card) {
            if (card.card_type == 'prepaid' || card.card_type == 'shakhtar_fanid_prepaid' || card.card_type == 'mc_prepaid_paypass_coala') {
              return true;
            } else {
              return false;
            }
        },
        findCard: function (cardId) {
            var index = -1;

            Cards.list.forEach(function (card, i) {
                if (card.id == cardId) {
                    index = i
                }
            });

            return index;
        },
        findMPCard: function (cardId) {
            var index = -1;

            Cards.listMP.forEach(function (card, i) {
                if (card.id == cardId) {
                    index = i
                }
            });

            return index;
        },
        getCardHash: function (cardNumber) {
            return cardNumber.substr(0, 4) + ' ' + cardNumber.substr(5, 2) + '** **** ' + cardNumber.substr(-4);
        },
        getList: function (force) {
            var defer = $q.defer();

            if (!force && (this.list.length || !Authentication.isLogged && Cards.data.mpStatus != 'AUTHORIZED')) {
                defer.resolve(Cards.list);
            } else {
                PortalApi.getCards().then(function(response) {
                    // angular.extend(Cards.list, response.plain());
                    Cards.initList(response.plain());

                    defer.resolve(Cards.list);
                    // defer.resolve(Cards.listMP);
                }, function (reason) {
                    defer.reject('');
                });
            }

            return defer.promise;
        },
        add: function (form) {
            var defer = $q.defer();
            var hash = Cards.getCardHash(form.number);

            if (!this.isUnicCard(hash)) {
                $translate('MYCARDS.ALREADY_EXISTS', {cardhash: hash})
                    .then(function (errorMessage) {
                        defer.reject(errorMessage);
                    });
            } else {
                PortalApi.addCard(form).then(function(result) {

                    if (result.status !== 'ok') {
                        $translate('MYCARDS.ERROR_ADD')
                            .then(function (errorMessage) {
                                defer.reject(errorMessage);
                            });
                    } else {
                        // Cards.list.push({
                        //     id: result.id,
                        //     card_type: result.card_type,
                        //     number: hash,
                        //     name: form.name
                        // });
                        //
                        // Cards.initList();
                        Cards.getList(true).then(function () {defer.resolve()});

                    }
                }, function (reason) {
                    $translate('MYCARDS.ERROR_ADD')
                        .then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                });
            }

            return defer.promise;
        },
        addMP: function (form) {
            var defer = $q.defer();
            var hash = Cards.getCardHash(form.pan);

            PortalApi.masterpassAddCard(form).then(function(result) {
                switch (result.status) {
                    case '3DS_VALIDATION':
                    case 'OTP_VALIDATION':
                        defer.resolve(result);
                        break;
                    default:
                        $translate('ERRORS.UNKNOWN_ERROR').then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                        break;
                }
            }, function (reason) {
                $translate('ERRORS.' + reason.data.text_сode).then(
                    function (errorMessage) {
                        defer.reject(errorMessage);
                    },
                    function () {
                        $translate('ERRORS.UNKNOWN_ERROR').then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                    }
                );
            });

            return defer.promise;
        },
        initMPWalletLink: function (form) {
            var defer = $q.defer();

            PortalApi.initMPWalletLink(form).then(function(result) {
                defer.resolve(result);
            }, function (reason) {
                $translate('ERRORS.' + reason.data.text_сode).then(
                    function (errorMessage) {
                        defer.reject(errorMessage);
                    },
                    function () {
                        $translate('ERRORS.UNKNOWN_ERROR').then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                    }
                );
            });

            return defer.promise;
        },
        confirmMPWalletLinkOTP: function (code) {
            var defer = $q.defer();

            PortalApi.confirmMPWalletLinkOTP(code).then(function(result) {
               defer.resolve(result);
            }, function (reason) {
                $translate('ERRORS.' + reason.data.text_сode).then(
                    function (errorMessage) {
                        defer.reject(errorMessage);
                    },
                    function () {
                        $translate('ERRORS.UNKNOWN_ERROR').then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                    }
                );
            });

            return defer.promise;
        },
        verifyCodeMP: function(data) {
            var defer = $q.defer();

            PortalApi.masterpassCodeValidate(data).then(function(result) {

                if (result.status == 'success' ) {
                    $translate('MYCARDS.MASTERPASS_ADD_SUCCESS').then(function(message) {
                        Notification.success({
                            message: message,
                            delay: 5000
                        });
                    });

                    Storage.mp_status = result.mp_status;
                    $rootScope.$broadcast("getList");
                } else if ( result.status == '3DS_VALIDATION' ) {

                    defer.resolve(result);
                } else {
                    $translate('MYCARDS.ERROR_ADD')
                        .then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                }
            }, function (reason) {
                $translate('MYCARDS.ERROR_ADD')
                    .then(function (errorMessage) {
                        defer.reject(errorMessage);
                    });
            });

            return defer.promise;
        },
        logoutMP: function() {
            PortalApi.masterpassLogout().then(function(result) {
                Cards.addMasterpassCard(false);
                Cards.list = [];
                Cards.listMP = [];
                Cards.data.mpStatus = '';
                Cards.data.card_type = '';
                Storage.removeItem('mp_status');
            },function (error) {
                $translate('NOTIFICATION.ERROR.OOPS_ERROR').then(function(message) {
                    Notification.error({
                        message: message,
                        delay: 5000
                    });
                });
            } );
        },
        remove: function (card) {
            var defer = $q.defer();
            var index,
                indexMP;
            if (card.card_type == "masterpass") {
                indexMP = this.findMPCard(card.id);
            } else {
                index = this.findCard(card.id);
            }

            if (index === -1 || indexMP === -1) {
                $translate('MYCARDS.NOT_EXIST', {cardhash: card.number})
                    .then(function (errorMessage) {
                        defer.reject(errorMessage);
                    });
            } else {
                PortalApi.deleteCard(card.id).then(function (res) {
                    if (res.status !== 'success') {
                        $translate('MYCARDS.ERROR_REMOVE')
                            .then(function (errorMessage) {
                                defer.reject(errorMessage);
                            });
                    } else {
                        if (res.mp_status) {
                            Storage.mp_status = res.mp_status;
                        }
                        if (indexMP != undefined) {
                            Cards.listMP.splice(indexMP, 1);
                        } else if (index != undefined) {
                            Cards.list.splice(index, 1);
                        }
                        defer.resolve();
                    }
                }, function (reason) {
                    $translate('MYCARDS.ERROR_REMOVE')
                        .then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                });
            }

            return defer.promise;
        },
        rename: function (card) {
            var defer = $q.defer();
            var index = this.findCard(card.id);
            if (index === -1) {
                $translate('MYCARDS.NOT_EXIST', {cardhash: card.number})
                    .then(function (errorMessage) {
                        defer.reject(errorMessage);
                    });
            } else {
                PortalApi.updateCard(card).then(function (res) {
                    if (res.status !== 'ok') {
                        $translate('MYCARDS.ERROR_UPDATE')
                            .then(function (errorMessage) {
                                defer.reject(errorMessage);
                            });
                    } else {
                        Cards.list[index].name = card.name;
                        defer.resolve();
                    }
                }, function (reason) {
                    $translate('MYCARDS.ERROR_UPDATE')
                        .then(function (errorMessage) {
                            defer.reject(errorMessage);
                        });
                });
            }

            return defer.promise;
        },
        setNumberToMask: function (user,number) {
            if (user) {
                Cards.data.numberToMask = '';
                Cards.data.userCardToUsed = true;
            } else {
                if (number) {

                    Cards.data.cardToId = false;

                    Cards.data.numberToMask = '9999 9999 9999 9999';
                    Cards.data.userCardToUsed = false;
                }
                $rootScope.$broadcast('countAmount');
            }
        },
        setTargetCard: function (card) {
            Cards.setNumberToMask(true, card.number);

            $timeout(function() {
                Cards.data.target.card = card.number;
                Cards.data.target.type = card.type;
                Cards.data.target.name = card.name;
                Cards.data.cardToId = card.id;
                Cards.data.userPasteTo = true;
                $rootScope.$broadcast('countAmount');
            });

        },
        userInputFnc: function (cardType) {
            if (cardType == 'number') {
                Cards.data.userPaste = false;
                Cards.data.numberMask = '9999 9999 9999 9999';
                Cards.data.id = 0;
                Cards.setNumberMask(false);
                //setFocus directive
                $rootScope.$broadcast('numberCard');
            } else if (cardType == 'target') {
                Cards.data.userPasteTo = false;
                Cards.data.target.card = '';
                //setFocus directive
                $rootScope.$broadcast('tergetCard');
            }
        },
        userInput: function () {
                Cards.data.id = null;

            Cards.setNumberMask();
        },
        setNumberMask: function (card, user) {
            if (user) {
                Cards.data.userCardUsed = true;
            } else {
                    Cards.data.number = '';
                    Cards.clearCardFields();
                Cards.data.userCardUsed = false;
            }
            // return Promise.resolve(true);
        },
        changeCardNumber: function (cardNumber, usrInpt, type) {
            var bin;
            var number = '';

            if (usrInpt) {
                Cards.userInput();
                if (cardNumber != undefined) {
                    number = cardNumber;
                }
            } else {
                number = Cards.data.number;
            }

            if (number) {
                if (number.length > 5) {
                    bin = number.replace(/\D/g, "").slice(0, 6);

                    switch (bin[0]) {
                        case '4':
                            Cards.data.type = 'visa';
                            break;
                        case '2':
                        case '5':
                            Cards.data.type = 'master';
                            break;
                        case '6':
                            Cards.data.type = 'maestro';
                            break;
                        default:
                            Cards.data.type = '';
                            break;
                    }
                }
                if (bin == 419317 || bin == 518282) {
                    Cards.data.usedPrepaidCard = true;
                } else {
                    Cards.data.usedPrepaidCard = false;
                }
            }

            if (cardNumber) {
                if (cardNumber.length == 16 || !usrInpt) {
                    $rootScope.$broadcast('changeCardNumber', type);
                }
            }

            Cards.reSetGAPay();
        },
        setClientCard: function (card, type) {
            Cards.data.numberMask = '';
            Cards.clearCardFields();
            if (type == 'masterpass') {
                Cards.mpCommission = true;
                Cards.data.masterpass = true;
            } else {
                Cards.data.masterpass = false;
            }
            Cards.data.masterpassAdd = false;

            $timeout(function() {
                Cards.data.number = card.number;
                Cards.data.name = card.name;
                Cards.data.type = card.type;
                Cards.data.card_type = card.card_type;
                Cards.data.id = card.id;

                Cards.data.userPaste = true;
                Cards.changeCardNumber(Cards.data.number, false, Cards.mpCommission);
                Cards.mpCommission = false;
            });
        },
        clearCardFields: function (card) {
            var same = false;
            if (card) {
                same = Cards.data.storedCardNum == card.number ? true : false;
                Cards.data.storedCardNum = card.number;
            } else {
                same = false;
            }
            if (Cards.data.viewExpire && !same) {
                Cards.data.cvc = '';
                Cards.data.cvv = '';
                Cards.data.viewExpire.month = '';
                Cards.data.viewExpire.year = '';
            }
            // return Promise.resolve(true);
        },
        checkNumber: function (ctrl) {
            if (ctrl.$valid && ctrl.$modelValue && ctrl.$modelValue.length == 16) {
                return true;
            }
        },
        checkMonth: function (ctrl) {
            if (ctrl.$valid && ctrl.$modelValue && ctrl.$modelValue.length == 2) {
                return true;
            }
        },
        checkYear: function (ctrl) {
            if (ctrl.$valid && ctrl.$modelValue && ctrl.$modelValue.length == 2) {
                return true;
            }
        },
        checkCvc: function (ctrl) {
            if (ctrl.$valid && ctrl.$modelValue && ctrl.$modelValue.length == 3) {
                return true;
            }
        },
        checkPhone: function (ctrl) {
            if (ctrl.$valid && ctrl.$modelValue && ctrl.$modelValue.length == 9) {
                return true;
            }
        },
        checkTargetNumber: function (ctrl) {
            if (ctrl.$valid && ctrl.$modelValue && ctrl.$modelValue.length == 16) {
                return true;
            }
        },
        cancelCards: function () {
            Cards.data.number = '';
            Cards.data.cvc = '';
            Cards.data.cvv = '';
            Cards.data.phone = '';
            Cards.data.target.card = '';
            Cards.data.target.phone = '';
            Cards.data.amount = '';
            Cards.data.viewExpire = {};
            Cards.data.cardFromId = 0;
            Cards.data.cardToId = 0;
        },
        getSourceObj: function (type) {
            var source = {
                cardFrom: {
                    id: 0,
                    number: '',
                    expire: '',
                    cvv: ''
                },
                cardTo: {
                    id: 0,
                    number: ''
                }
            };

            if (Cards.data.id) {
                source.cardFrom.id = Cards.data.id;
            } else if (Cards.data.number) {
                source.cardFrom.number = Cards.data.number.replace(/\D/g, '');
            }

            if (Cards.data.viewExpire.year && Cards.data.viewExpire.month) {
                source.cardFrom.expire = Cards.data.viewExpire.year + '' + Cards.data.viewExpire.month;
            }

            if (Cards.data.cvv) {
                source.cardFrom.cvv = Cards.data.cvv;
            }

            if (Cards.data.cardToId) {
                source.cardTo.id = Cards.data.cardToId;
            } else if (Cards.data.target.card) {
                source.cardTo.number = Cards.data.target.card.replace(/\D/g, '');
            }

            if (type == 'mp') {
                return source.cardFrom;
            } else if (Cards.data.isGAPay) {
                if(source.cardTo.number || source.cardTo.id) {
                    source.cardFrom = {
                        number: '4242424242424242',
                        expire: '5512',
                        cvv: '111'
                    }

                    return source;
                } else {
                    return {
                        cardFrom: {
                            type: Cards.gaPayData.type,
                            payload: Cards.gaPayData.payload
                        }
                    };
                }

            } else {
                return source;
            }
        },
        addMasterpassCard: function(status) {
            Cards.data.masterpassAdd = status;
            Cards.data.masterpass = false;
            Cards.data.number = '';
            Cards.data.name = '';
            Cards.data.type = '';
            Cards.userInputFnc('number');
        },
        setGAPay: function (source_type, payload) {
            Cards.gaPayData.type = source_type;
            Cards.gaPayData.payload = payload;
            Cards.data.isGAPay = true;
        },
        reSetGAPay: function () {
            Cards.gaPayData.cardMaskedNumber = '';
            Cards.gaPayData.cardPaymentNetwork = '';
            Cards.gaPayData.type = '';
            Cards.gaPayData.payload = '';
            Cards.data.isGAPay = false;
        }
    };

    $rootScope.$on('logout', function () {
        Cards.list = [];
        Cards.listMP = [];
        Cards.data.mpStatus = null;
    });

    return Cards;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/client-cards/services/client-cards.js
 ** module id = 76
 ** module chunks = 1
 **/